import React from 'react';

import Icon from '../../../../elements/icons/Icon';
import './UploadButton.scss';

export default class UploadButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cid: _.uniqueId('c'),
        };
    }
    render() {
        return (
            <div className="UploadButton">
                <button type="button" onClick={this.handleOpenDialog.bind(this)}>
                    <Icon src={this.props.icon} color={this.props.color} />
                </button>
                <input
                    ref={el => (this.imgInput = el)}
                    type="file"
                    accept={this.props.accept}
                    multiple={true}
                    onChange={this.handleImagesSelected.bind(this)}
                    key={this.state.cid}
                />
            </div>
        );
    }
    handleOpenDialog() {
        this.imgInput.click();
    }
    handleImagesSelected(e) {
        if (this.props.onFilesSelected) {
            this.props.onFilesSelected(e.target.files);
            this.setState({cid: _.uniqueId('c')});
        }
    }
}
